<template>
  <div class="item">
    <div class="item-col-left">
      <span> <img :src="item.imageUrl" width="100" height="100"/> </span>
    </div>
    <div class="item-col-right">
      <div class="w-100">
        <!-- The whole row toggles the product, as on the sold-out page; the checkbox is display-only
             (pointer-events:none) so a click on it cannot toggle twice. For a product with variants it is
             the master: ticked = the whole product, indeterminate = only some of its variants. -->
        <div class="flex-box bo_clickable-row" @click="$emit('toggleItem', item)">
          <div>
            <span class="item-title">{{ item.menuNr }} &nbsp;&nbsp;  {{item.name}} </span>
            <br/>
            <span class="description">{{item.description}}</span><br/>
            <div v-if="locationNames.length > 0" class="bo_item-locations">
              <span v-if="soldEverywhere" class="bo_item-location-badge">Alle avdelinger</span>
              <template v-else>
                <span v-for="name in locationNames" :key="name" class="bo_item-location-badge">{{ name }}</span>
              </template>
            </div>
          </div>
          <div class="cart-buttons-panel">
            <input type="checkbox" :checked="whole" :indeterminate.prop="partial" class="checkbox bo_checkbox-display" />
          </div>
        </div>

        <!-- One row per variant: tick only the ones the discount is for. Ticking them all is the same as
             ticking the product, and is saved that way, so a variant added later is covered too. -->
        <div v-for="variant in variants" :key="variant.id" class="flex-box bo_clickable-row bo_discount-variant-row"
             @click="$emit('toggleVariant', item, variant)">
          <div class="ms-3">{{ variant.name }}</div>
          <div class="cart-buttons-panel">
            <input type="checkbox" :checked="selectedVariantIds.indexOf(variant.id) > -1" class="checkbox bo_checkbox-display" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DiscountSelectionUtil from "@/util/DiscountSelectionUtil";

export default {
  props: {
    item: { type: Object, required: true },
    whole: { type: Boolean, default: false },                    //The whole product, every variant
    selectedVariantIds: { type: Array, default: () => [] },      //All of them when whole
    locationNames: { type: Array, default: () => [] },           //Empty for a single-location merchant
    soldEverywhere: { type: Boolean, default: false }
  },
  emits: ['toggleItem', 'toggleVariant'],
  computed: {
    variants(){
      return DiscountSelectionUtil.variantsOf(this.item);
    },
    partial(){
      return !this.whole && this.selectedVariantIds.length > 0;
    }
  }
}
</script>

<style scoped>
.checkbox{
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.bo_discount-variant-row{
  padding: 8px 0;
  border-top: 1px solid var(--bo-line);
}
</style>
